import React, { useEffect, useState } from 'react';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as staffActions from '../../Redux/Actions/staff';
import * as userAuthActions from '../../Redux/Actions/user';
import { toastMessage } from '../../utils/toast';
import { validationError } from '../../utils/initiate';
import ResetPasswordModal from './resetPasswordModal.js';

const UpdateStaff = ({history, match}) => {

    const [id, setID] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [extensionNumber, setExtensionNumber] = useState('');
    const [emiratesId, setEmiratesId] = useState('');

    const [departmentsList, setDepartmentsList] = useState([]);
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [departmentID, setDepartmentID] = useState('');
    const [masterProcessID, setMasterProcessID] = useState('');
    // const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedMasterProcess, setSelectedMasterProcess] = useState([]);
    const [selectedProcess, setSelectedProcess] = useState([]);

    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [resetModal, setResetModal] = useState(false);
    const [resetButtonLoading, setResetButtonLoading] = useState(false);
    const { t } = useTranslation();
    const {staffID} = match.params;

    useEffect(() => {
        staffActions.getIndividual(staffID).then(res => {
            if(res && res.data[0]){
                let data = res.data[0].staffInfo;
                let skillInfo = res.data[0].skillInfo;
                skillInfo = skillInfo.map(({id}) => id);
                setID(data.id)
                setName(data.name);
                setEmail(data.email);
                setMobileNumber(data.mobileNumber);
                setEmiratesId(data.emiratesId);
                setExtensionNumber(data.extensionNumber || '');
                handleGetAllServices(skillInfo);
            }else{
                toastMessage('error', `Staff added Failed`);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [staffID]);

    const handleGetAllServices = (skillInfo) => {
        setLoading(true);
        staffActions.getAllServices().then(res => {
            if(res && res.data){
                setLoading(false);
                setDepartmentsList(res.data.departments);
                setSelectedProcess(skillInfo);
                handleSetMasterProcessIDs(res.data.departments, skillInfo);
            }else{
                toastMessage('error', 'Unable to load the process');
            }
        }).catch(err => {
            toastMessage('error', `Unable to load the process`);
        });
    };

    const handleSetMasterProcessIDs = (departments, skillIds) => {
        let masterProcessIds = [];
        for (let i=0; i < departments.length; i++) {
            let mpdata = departments[i].masterProcess.map(({id, process}) => ({
                id, 'process': process.map(({id}) => id)
            }));
            for (let i=0; i < mpdata.length; i++) {
                let isMasterProcess = false;
                if (mpdata[i].process.length === 1) {
                    isMasterProcess = skillIds.includes(mpdata[i].process[0]);
                } else {
                    let multipleP = [];
                    mpdata[i].process.forEach(id =>
                        skillIds.includes(id) ? multipleP.push(id) : ''
                    );
                    isMasterProcess = multipleP.length === mpdata[i].process.length; 
                }
                if (isMasterProcess) {
                    masterProcessIds.push(mpdata[i].id)
                }
            }
        }
        setSelectedMasterProcess(masterProcessIds);
    };

    const handleList = (key, ID) => {
        let list = [];
        if (key === 'department'){
            list = departmentsList.filter(({id}) => id === ID)[0].masterProcess;
            setMasterProcessList(list);
        }
        else{
            list = masterProcessList.filter(({id}) => id === ID)[0].process;
            setProcessList(list);
        }
    };

    // const handleSelectedDepartment = (event) => {
    //     let list = departmentsList.filter(({id}) => id === parseInt(event.target.value, 10))[0].masterProcess;
    //     if (event.target.checked){
    //         setSelectedDepartment([...selectedDepartment, parseInt(event.target.value, 10)]);
    //         list = list.map(({id}) => id);
    //         let newList = [...list, ...selectedMasterProcess]
    //         let rmDuplicates = [...new Set(newList)];
    //         setSelectedMasterProcess(rmDuplicates);
    //     }else{
    //         const newList = selectedDepartment.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
    //         setSelectedDepartment(newList)
    //         list.map(({id}) => {
    //             let Index = selectedMasterProcess.indexOf(id);
    //             return (Index === -1) ? '' : selectedMasterProcess.splice(Index, 1);
    //         });
    //         setSelectedMasterProcess(selectedMasterProcess);
    //     }
    // };
  
    const handleSelectedMasterProcess = (event, deptID, mpID) => {
        let mpList = departmentsList.filter(({id}) => id === parseInt(deptID, 10))[0].masterProcess;
        mpList = mpList.filter(({id}) => id === parseInt(mpID, 10))[0].process;
        if (event.target.checked) {
            mpList = mpList.map(({id}) => id);
            let newList = [...mpList, ...selectedProcess];
            let rmDuplicates = [...new Set(newList)];
            setSelectedProcess(rmDuplicates);
            setSelectedMasterProcess([...selectedMasterProcess, parseInt(event.target.value, 10)]);
        } else {
            const newList = selectedMasterProcess.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
            setSelectedMasterProcess(newList);
            mpList.map(({id}) => {
                let Index = selectedProcess.indexOf(id);
                return (Index === -1) ? '' : selectedProcess.splice(Index, 1);
            });
            setSelectedProcess(selectedProcess);
        }
    };

    const handleSelectedProcess = (event, mpID) => {
        let pList = masterProcessList.filter(({id}) => id === parseInt(mpID, 10))[0].process;
        if (event.target.checked) {
            let updatedP = [...selectedProcess, parseInt(event.target.value, 10)];
            let updatedMP = [];
            if (pList.length === 1) {
                updatedMP = [...selectedMasterProcess, parseInt(mpID, 10)];
            } else {
                let multipleP = [];
                pList.forEach(({id}) =>
                    updatedP.includes(id) ? multipleP.push(id) : ''
                );
                updatedMP = (pList.length === multipleP.length) ? [...selectedMasterProcess, parseInt(mpID, 10)] : selectedMasterProcess;
            }
            setSelectedMasterProcess(updatedMP);
            setSelectedProcess(updatedP);
        } else {
            const mPList = selectedMasterProcess.map(item => (item === mpID) ? false : item).filter(Boolean);
            setSelectedMasterProcess(mPList);
            const newList = selectedProcess.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
            setSelectedProcess(newList);
        }
    };
      
    // const isDeptChecked = (id) => selectedDepartment.find(item => item === parseInt(id, 10));
    const isMPChecked = (id) => {
        let response = selectedMasterProcess.find(item => item === parseInt(id, 10));
        return (response === undefined) ? false : response;
    };
    const isPChecked = (id) => {
        let response = selectedProcess.find(item => item === parseInt(id, 10));
        return (response === undefined) ? false : response;
    };

    const handleResetPassword = () => {
        setResetButtonLoading(true);
        userAuthActions.resetPassword(staffID).then(res => {
            if(res && res.data){
                toastMessage('success', (res && res.message) || 'Reset password sent successfully');
                setResetModal(false);
            }
            setResetButtonLoading(false);
        }).catch(err => {
            toastMessage('error', 'Unable to send the reset password');
        });
    };

    const handleUpdateStaff = () => {
        setButtonLoading(true);
        if((name !== '') && (email !== '') && (mobileNumber !== '') && (selectedProcess.length !== 0)){
            let payload = {
                id, name, email, mobileNumber,emiratesId, extensionNumber, skillIds: selectedProcess
            };
            staffActions.update(payload).then(res => {
                if(res && res.data){
                    toastMessage('success', `Staff updated successfully`);
                    setName(''); setEmail(''); setMobileNumber(''); setExtensionNumber(''); setEmiratesId(''); setSelectedMasterProcess([]); setSelectedProcess([]);
                    history.push('/staff');
                }else{
                    toastMessage('error', `Staff updated Failed`);
                }
                setButtonLoading(false);
            }).catch(err => {
                setButtonLoading(false);
                toastMessage('error', err.response.data.message);
                (err.response.status === 400) && err.response && validationError(err.response);
            });
        }else{
            setButtonLoading(false);
            toastMessage('error', `Enter the correct staff details`);
        }
    };

    return(
        <>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    <div className="card border-0 card-stretch">
                        <div className="card-header border-0 py-3">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="text-muted c-pointer my-2" onClick={() => history.push('/staff')}>{t("staffManagement.manageStaff.title")}</span> /
                                <span className="card-label font-weight-bolder text-dark ms-1">{t("staffManagement.updateStaff.title")}</span>
                            </h3>
                        </div>
                        {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center'}} />
                        : <div className="card-body pt-0 pb-3">
                            <div className="row mb-3">
                                <label className="form-label mb-1">{t("staffManagement.updateStaff.name")} <span className="text-danger">*</span></label>
                                <input placeholder={t("staffManagement.updateStaff.namePlaceholder")} type="text" className="form-control"
                                    name="email" value={name} onChange={e => setName(e.target.value)}
                                />
                            </div>
                            <div className="row mb-3">
                                <label className="form-label mb-1">{t("staffManagement.updateStaff.email")} <span className="text-danger">*</span></label>
                                <input placeholder={t("staffManagement.updateStaff.emailPlaceholder")} type="text" className="form-control"
                                    name="email" value={email} onChange={e => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="row mb-3">
                                <label className="form-label mb-1">{t("staffManagement.updateStaff.mobileNumber")} <span className="text-danger">*</span></label>
                                <input placeholder={t("staffManagement.updateStaff.mobileNumberPlaceholder")} type="text" className="form-control"
                                    name="mobileNumber" value={mobileNumber} onChange={e => setMobileNumber(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label mb-1">{t("staffManagement.updateStaff.emiratesID")} <span className="text-danger">*</span></label>
                                <input placeholder={t("staffManagement.updateStaff.emiratesIDPlaceholder")} type="text" className="form-control"
                                    name="mobileNumber" value={emiratesId} onChange={e => setEmiratesId(e.target.value)}
                                />
                            </div>
                            {/* <div className="row mb-3">
                                <label className="form-label mb-1">Extension Number <span className="text-danger">*</span></label>
                                <input placeholder={`Update the extension number`} type="text" className="form-control"
                                    name="extensionNumber" value={extensionNumber} onChange={e => setExtensionNumber(e.target.value)}
                                />
                            </div> */}
                            <div className="mb-2">
                                <label className="form-label mb-2">{t("staffManagement.addStaff.department")} <span className="text-danger">*</span></label>
                                <div>
                                    {departmentsList.map(({name, id}, index) => 
                                        <div className='d-flex flex-column' key={id}>
                                            <div key={id} className='d-flex align-items-center mb-2 c-pointer'>
                                                <span className="me-1">{index+1}.</span>
                                                {/* <input type='checkbox' className='me-2' value={id} checked={isDeptChecked(id)} onChange={handleSelectedDepartment} /> */}
                                                <p className="m-0" onClick={() => {handleList('department', id); setDepartmentID(id === departmentID ? '' : id)}}>{name}</p>
                                            </div>
                                            {(departmentID === id) && (masterProcessList.length !== 0) && <div className="mb-3 ms-4">
                                                <label className="form-label mb-1">{t("staffManagement.addStaff.masterProcess")}</label>
                                                <div>
                                                    {masterProcessList.map(({name, id: mpID}) =>
                                                        <div className="d-flex flex-column" key={mpID}>
                                                            <div key={mpID} className='d-flex align-items-center mb-1 c-pointer'>
                                                                <input type='checkbox' className='me-2' name={name} id={name} value={mpID}
                                                                    checked={isMPChecked(mpID)} onChange={e => handleSelectedMasterProcess(e, id, mpID)} />
                                                                <p className="m-0" onClick={() => {handleList('masterProcess', mpID); setMasterProcessID(mpID === masterProcessID ? '' : mpID)}}>{name}</p>
                                                            </div>
                                                            {(masterProcessID === mpID) && (processList.length !== 0) && <div className="mb-3 ms-4">
                                                                <label className="form-label mb-1">{t("staffManagement.addStaff.process")}</label>
                                                                <div>
                                                                    {processList.map(({name, id: pID}) =>
                                                                        <div key={pID} className='d-flex align-items-center mb-1 c-pointer'>
                                                                            <input type='checkbox' className='me-2' name={name} id={name} value={pID}
                                                                                checked={isPChecked(pID)} onChange={e => handleSelectedProcess(e, mpID)} />
                                                                            <label className="m-0" htmlFor={name}>{name}</label>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <button disabled={buttonLoading} onClick={handleUpdateStaff} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold">
                                {t("staffManagement.updateStaff.title")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>

                            <div className="card card-stretch p-3 d-flex flex-row align-items-center justify-content-center mt-5">
                                <p className="m-0">{t("staffManagement.updateStaff.sendResetPasswordMail")}</p>
                                <button disabled={buttonLoading} onClick={() => setResetModal(true)} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold ms-2">
                                    {t("staffManagement.updateStaff.reset")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                </button>
                            </div>
                        </div>}
                    </div>
                    {resetModal && <ResetPasswordModal t={t} showModal={resetModal} loading={resetButtonLoading} handleOk={handleResetPassword} handleModalClose={() => setResetModal(false)} />}
                </div>
            </div>
        </>
    );
};

export default UpdateStaff;